"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNewDrawer = void 0;
const material_1 = require("@mui/material");
const useNewDrawer = ({ removeHeader, hasOverflow, hasRadius, hasHeaderDivider, mobileWidth = false, }) => {
    const theme = (0, material_1.useTheme)();
    const container = {
        backgroundColor: theme.qlub.palette.white.main,
        borderRadius: hasRadius ? '30px 30px 0 0' : 0,
        padding: '12px 0',
        paddingTop: removeHeader ? '12px' : 0,
        overflowY: hasOverflow ? 'scroll' : 'hidden',
        width: '100%',
        maxWidth: mobileWidth ? '552px' : '100%',
    };
    const content = {
        padding: '0 24px',
    };
    const stickyHeader = {
        position: 'sticky',
        top: 0,
        borderBottom: hasHeaderDivider ? '1px solid #EBECF2' : 'none',
        background: theme.qlub.palette.white.main,
        padding: '12px 24px',
        zIndex: 1000,
    };
    const captionStyle = {
        padding: '.5rem',
        color: theme.qlub.palette.onSurfaceColors.mediumEmphasis,
        fontSize: '.75rem',
    };
    const closeButton = {
        background: 'transparent',
        padding: '.1rem',
        marginBottom: '0.4rem',
    };
    const logoHeader = {
        minWidth: 'auto',
        maxWidth: 'auto',
        minHeight: '3.75rem',
        maxHeight: '3.75rem',
        objectFit: 'contain',
    };
    return { container, captionStyle, content, stickyHeader, closeButton, logoHeader };
};
exports.useNewDrawer = useNewDrawer;
exports.default = exports.useNewDrawer;
